import React, { useEffect } from "react";
import "./faqs.scss";
import CommonBanner from "../../components/commonBanner/CommonBanner";
import { CustomAccordion } from "../../components/Accordion/Accordion";
import { flower, sun } from "../../source";

const faqData = [
  {
    id: 1,
    title: "What inspired the creation of Pathways & Perspectives ?",
    content:
      "Pathways & Perspectives’ raison d’être is to share invaluable insights, knowledge and experience from inspirational figures in the fields of wellness and spirituality. The inspiration for Pathways & Perspectives came to Marouf Tirad while on a 6 month pilgrimage in India. Tirad met so many amazing people during his time there and decided to create a platform to share ancient teachings in a modern context, benefiting people with internet access the world over.",
  },
  {
    id: 2,
    title: "How do I subscribe to join your mailing list?",
    content:
      "Subscribing to our mailing list is easy! Just scroll to the bottom of any page on our website and enter your email address in the subscription box. You’ll receive regular updates about new episodes, upcoming interviews, and special content just for our subscribers.",
  },
  {
    id: 3,
    title: "How can I contact the team for collaborations and partnerships?",
    content:
      "Would you like to contribute to a topic of discussion, share your knowledge, or simply explore a new idea? Are you looking to promote your event or product that our audience would be interested in? We welcome you! You can reach out to our team through the contact form on the website or email us directly at <a href='mailto:seek@pathwaysperspectives.com'>seek@pathwaysperspectives.com</a>. We look forward to hearing from you.",
  },
  {
    id: 4,
    title: "Can we partake in interviews?",
    content:
      "Yes, you definitely can! We’re open to giving you a platform to share your thoughts, no matter where you are in the world. Simply contact us at <a href='mailto:seek@pathwaysperspectives.com'>seek@pathwaysperspectives.com</a> with a brief of the topic you’d like to explore we will be in-touch.",
  },
  {
    id: 5,
    title: "Can we share our reflections and blogs?",
    content:
      "Absolutely! Pathways & Perspectives is an open book, and we welcome contributions from all walks of life. Whether it’s reflections, blogs, or personal insights, we encourage you to share your thoughts with our community. Contact us at <a href='mailto:seek@pathwaysperspectives.com'>seek@pathwaysperspectives.com</a> for more details and we will be in-touch.",
  },
  {
    id: 6,
    title: "Do you have a physical address?",
    content:
      "Currently, we are a digital platform, so we don’t have a physical address at this time. However, as we continue to grow, we’ll keep you updated on any developments, including potential locations. Stay tuned!",
  },
];

const FAQS = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <section className="faq_sec1">
        <CommonBanner title="FAQS" linkText1="FAQs" />
      </section>

      <section className="faq_sec2">
        <img src={flower} alt="flower" className="flower_img" />
        <div className="my_container">
          <h2 className="faq_main_title">Commonly Asked Questions</h2>

          <CustomAccordion firstActive={true} items={faqData} />
        </div>
      </section>

      <section className="faq_sec3">
        <img src={sun} alt="sun" className="sun_img" />
      </section>
    </>
  );
};

export default FAQS;
